import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-products-phishing-simulation',
  templateUrl: './products-phishing-simulation.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./products-phishing-simulation.component.scss']
})
export class ProductsPhishingSimulationComponent implements OnInit {

currentLanguage = this.commonService.currentLanguage;
header:string ='Phishing Simulation2';
description:string ='Assess employees readiness with realistic phishing2';
joinChat:boolean=false;
imagePath: string;
hasBtn:boolean = true;
routerHeroButton="/contact-us";
buttonText="Request a demo";
isProductsPage: boolean = true;
subImgUrl= '../assets/svg/awarenessPlatform.svg'
isProductLogo: boolean = true;
logoPath ='../assets/svg/awareness 10®.svg'

imageText="Security Awarness";
routerLink="/products-awareness";
imageTextPath="../../../../assets/images/undraw_mobile_search.png";
Text="Learn more";
routerButton="/products-awareness";
imageUrl='../../../../assets/images/Frame48096932.jpg';
subTitle= 'Automated tailored training with updated content';
items = [
'Continuous updating of phishing models by our cyber security team based on continuous research and latest surveys from various sources',
'Available in both Arabic and English to suit the different workers in your facility',
'Create your form directly in the platform without any software intervention with our all-in-one form editor',
'The models provide different levels of sophistication of the attacks Easy - Medium - Advanced'
];

tileSectionTwo= 'Frequently Updated Phishing Templates';
descriptionSectionTwo= 'Simulating attacks on the Kingdom';
employeeButtonListText ='Request a demo'
employeeImgListPath= '../../../../assets/svg/undraw_collaborating_re_l43g1.svg' 
employeeRouterListButton = '/contact-us'

sectionInputTwoCards:any=[{
  description:'Pre-built libraries of awareness content including courses, posters, and phishing templates. ',
  imagePath:'../../../../assets/images/image4.png',
},
{
  description:'New content is added continuously to keep your program up to date with latest threats trends. ',
  imagePath:'../../../../assets/images/image3.png',
},
{
  description:'Launch campaigns with professional content in seconds. ',
  imagePath:'../../../../assets/images/image2.png',
},
{
  description:'New content is added continuously to keep your program up to date with latest threats trends. ',
  imagePath:'../../../../assets/images/image1.png',
}]




  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    if(this.currentLanguage == 'en'){
      this.imagePath = "../../../../assets/images/Hero-Section Phishing  En.png"
    }else{
      this.imagePath = "../../../../assets/images/Hero-Section Phishing  Ar.png"
    }
  }

}
